import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { CloudProvider } from './context/CloudContext';
// Font Awesome Free, self-hosted from node_modules: the webfonts are bundled by
// the build, so the console needs no CDN at runtime. Imported before the app
// stylesheet so global.css can still override icon sizing.
import '@fortawesome/fontawesome-free/css/all.min.css';
import './styles/global.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <CloudProvider>
          <App />
        </CloudProvider>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);
